import { call, put, delay } from "redux-saga/effects";
import { ordersApi, userApi } from "@services/api";
import { addOrderActions, getCartActions } from "../slices";
import { showFailureToast } from "@helpers";
import { getProfileActions } from "@redux/modules/user/slices";

function* addOrderWorker({ payload }) {
  yield delay(300);
  try {
    yield put(addOrderActions.pending());
    const response = yield call(ordersApi.addOrder, payload.data);
    yield put(addOrderActions.success(response));

    yield put(getCartActions.pending());
    const responseGet = yield call(ordersApi.getCart, payload);
    yield put(getCartActions.success(responseGet));

    yield put(getProfileActions.pending());
    const responseProfile = yield call(userApi.getProfile);
    yield put(getProfileActions.success(responseProfile));

    yield put(payload.navigate());
    // yield put(payload.navigate(response.data));
    // TODO: handle callback | onSuccess
  } catch (error) {
    yield put(addOrderActions.failure(error));
    // if (error.Message) {
    //   showFailureToast(error.Message);
    // } else {
    //   showFailureToast("Checkout this order failure!");
    // }
    showFailureToast("Checkout this order failure!");
    // TODO: handle callback | onFailure
  }
}

export { addOrderWorker };
